import { VueController } from 'util/vue_controller'

// Connects to data-controller="supplier-pricing-participations"
export default class extends VueController {
  static vueComponent = 'supplier-pricing-participations'

  static targets = ['tableBody']

  static values = {
    pricingPrograms: Array,
    distributors: Array
  }

  get props () {
    return {
      pricingPrograms: this.pricingProgramsValue,
      distributors: this.distributorsValue
    }
  }

  get vueTarget () {
    return this.tableBodyTarget
  }
}
